// One way to print a timestamp on a staff screen. The screens that grew
// their own copy differed only in what they say about nothing at all, so
// that is the argument.

export function fmtDate(iso: string | null | undefined, fallback = ""): string {
  if (!iso) return fallback;
  const t = Date.parse(iso);
  if (Number.isNaN(t)) return fallback;
  return new Date(t).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}

// A day count, in one voice. The past is the part that matters: a deadline
// that has gone by reads "12d ago", and never "0d" - a filing bar that
// closed years ago must not look like one closing today.
export function fmtDays(days: number): string {
  return days < 0 ? `${Math.abs(days)}d ago` : `${days}d`;
}

/** A calendar day ("1990-03-02") in the same voice, built from its
    parts: parsed as an instant it would be UTC midnight, which in
    Philadelphia is the evening before. Anything else comes back as is. */
export function fmtDay(day: string): string {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(day);
  if (!m) return day;
  return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3])).toLocaleDateString("en-US", {
    month: "short",
    day: "numeric",
    year: "numeric",
  });
}
